module.exports = __webpack_public_path__ + "img/elementosproteccion.388d728b.png";